import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import { StyledWrapper } from "./page.style";
import Container from "../form/container";
import useAppContext from "../../../../hooks/useAppContext";

const Page = () => {
  const { axios } = useAppContext();
  const { slug } = useParams();
  const [challenge, setChallnge] = useState(null);

  useEffect(() => {
    axios
      .get(`admin/contests/${slug}`)
      .then((resp) => setChallnge(resp.data.data));
  }, [slug]);

  return (
    <StyledWrapper>
      {challenge && <Container challenge={challenge} />}
    </StyledWrapper>
  );
};

export default Page;
